<div class="tw-p-4 tw-bg-white tw-rounded-xl">
  <div class="tw-flex tw-flex-col tw-gap-3 tw-mb-4 sm:tw-flex-row">
    <app-event-time-picker
      class="tw-flex-1"
      label="Opening Time"
      [flexInRow]="true"
      [hour]="startHour()"
      [minute]="startMinute()"
      [hourOptions]="hourOptions"
      [minuteOptions]="minuteOptions"
      (hourChange)="startHour.set($event)"
      (minuteChange)="startMinute.set($event)"
    />
    <app-event-time-picker
      class="tw-flex-1"
      label="Closing Time"
      [flexInRow]="true"
      [hour]="endHour()"
      [minute]="endMinute()"
      [hourOptions]="hourOptions"
      [minuteOptions]="minuteOptions"
      (hourChange)="endHour.set($event)"
      (minuteChange)="endMinute.set($event)"
    />
  </div>
  <div class="tw-flex tw-flex-col tw-gap-2 tw-mb-4">
    <div class="tw-flex tw-items-center tw-gap-2 tw-p-3 tw-rounded-lg tw-bg-blue-50 tw-border tw-border-blue-200">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 0C5.61553 0 4.26215 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32121C0.00303299 5.6003 -0.13559 7.00776 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73784 14 8.38447 14 7C13.998 5.14411 13.2598 3.36482 11.9475 2.0525C10.6352 0.74019 8.85589 0.00203812 7 0ZM6.65 2.8C6.85767 2.8 7.06068 2.86158 7.23335 2.97696C7.40602 3.09233 7.5406 3.25632 7.62008 3.44818C7.69955 3.64004 7.72034 3.85116 7.67983 4.05484C7.63931 4.25852 7.53931 4.44562 7.39246 4.59246C7.24562 4.73931 7.05853 4.83931 6.85485 4.87982C6.65117 4.92034 6.44005 4.89954 6.24818 4.82007C6.05632 4.7406 5.89233 4.60602 5.77696 4.43335C5.66158 4.26068 5.6 4.05767 5.6 3.85C5.6 3.57152 5.71063 3.30445 5.90754 3.10754C6.10445 2.91062 6.37152 2.8 6.65 2.8ZM8.4 10.5H5.6C5.41435 10.5 5.2363 10.4262 5.10503 10.295C4.97375 10.1637 4.9 9.98565 4.9 9.8C4.9 9.61435 4.97375 9.4363 5.10503 9.30502C5.2363 9.17375 5.41435 9.1 5.6 9.1H6.3V7H5.6C5.41435 7 5.2363 6.92625 5.10503 6.79497C4.97375 6.6637 4.9 6.48565 4.9 6.3C4.9 6.11435 4.97375 5.9363 5.10503 5.80502C5.2363 5.67375 5.41435 5.6 5.6 5.6H7C7.18565 5.6 7.3637 5.67375 7.49498 5.80502C7.62625 5.9363 7.7 6.11435 7.7 6.3V9.1H8.4C8.58565 9.1 8.7637 9.17375 8.89498 9.30502C9.02625 9.4363 9.1 9.61435 9.1 9.8C9.1 9.98565 9.02625 10.1637 8.89498 10.295C8.7637 10.4262 8.58565 10.5 8.4 10.5Z" fill="#1C64F2"/>
      </svg>
      <p class="tw-text-sm tw-text-gray-700 tw-italic tw-font-inter">
        You can customize these hours for specific days if schedules vary.
      </p>
    </div>
  </div>
  <div class="tw-flex tw-gap-3">
    <button
      type="button"
      (click)="reset()"
      class="tw-flex-1 tw-py-2 tw-px-4 tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-text-gray-800 tw-text-xs tw-font-medium tw-font-inter hover:tw-bg-gray-50"
    >
      Reset
    </button>
    <button
      type="button"
      (click)="apply()"
      class="tw-flex-1 tw-py-2 tw-px-4 tw-rounded-lg tw-bg-blue-600 tw-text-white tw-text-xs tw-font-medium tw-font-inter hover:tw-bg-blue-700"
    >
      Apply
    </button>
  </div>
</div>
